<template>
  <router-view />
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  mounted() {
    this.handleExpiredToken()
  },
  methods: {
    async handleExpiredToken() {
      const token = localStorage.getItem('tokenPengendalian')
      const user = JSON.parse(localStorage.getItem('userPengendalian') || '{}')

      // Skip jika belum login (tidak ada token / data user)
      if (!token || !user.id) return

      try {
        await axios.get(`${localStorage.getItem('baseapiPengendalian')}api/user/${user.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('tokenPengendalian')
          localStorage.removeItem('userPengendalian')
          window.location.reload()
        }
      }
    },
  },
}
</script>

<style src="./styles/theme.scss" lang="scss" />

<style>
.custom-disabled {
  background-color: white !important; /* ubah warna background */
  color: black !important; /* ubah warna teks */
  opacity: 1; /* hilangkan efek pudar */
  cursor: not-allowed; /* opsional, kasih tanda kursor */
}

/* merah muda untuk penolakan/perbaikan */
.row-tolak td {
  background-color: #fddede !important;
  color: #ff0019 !important;
}

.row-perbaikan {
  background-color: #f8d7da !important;
  color: #ff0019 !important;
}

/* hijau muda untuk terbit */
/* .row-setujui td {
  background-color: #d4f5dd !important;
  color: #00c12d !important;
} */

.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000 !important;
  flex-direction: column;
  user-select: none;
}
.loading-circle {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-left-color: #ababab;
  animation: circleanimation 0.45s linear infinite;
}
.loading-text {
  margin-top: 15px;
  color: #808080;
  font-size: 12px;
  text-align: center;
}
@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>
